import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { UnifiedPrivacy } from '@prezi/presentation-service-client';
import { unifiedPrivacyActions } from '../../../store/actions/unifiedPrivacyActions';
import { Dumb } from '..';
import { isPermissionNotAllowedInOrg, isPermissionNotAllowedWithCurrentLicense } from '../../../api/userPermissions';
import { documentToProductName } from '../../../utils/mappings';
import { getGlassboxLogger } from '../../../glassboxLogger';
const controlContextSelector = state => {
  var _state$unifiedPrivacy, _state$userPermission, _state$document$value, _state$document$value2, _state$featureSwitche, _state$unifiedPrivacy2, _state$unifiedPrivacy3;
  const isOwner = (_state$unifiedPrivacy = state.unifiedPrivacy.value) === null || _state$unifiedPrivacy === void 0 ? void 0 : _state$unifiedPrivacy.is_owner;
  const unifiedPrivacyPermissions = (_state$userPermission = state.userPermissions.value) === null || _state$userPermission === void 0 ? void 0 : _state$userPermission.unifiedPrivacy.set;
  const viewLinkCount = state.viewlinks.value.allIds.length;
  const isPresentDocument = ((_state$document$value = state.document.value) === null || _state$document$value === void 0 ? void 0 : _state$document$value.schema_version_name) === 'PITCH';
  const isDesignDocument = ((_state$document$value2 = state.document.value) === null || _state$document$value2 === void 0 ? void 0 : _state$document$value2.schema_version_name) === 'INFOGRAM';
  const areViewLinksSupported = isPresentDocument || isDesignDocument && ((_state$featureSwitche = state.featureSwitches.value) === null || _state$featureSwitche === void 0 ? void 0 : _state$featureSwitche['prezi-design-analytics-viewlinks']);
  const isDocumentOpen = ((_state$unifiedPrivacy2 = state.unifiedPrivacy.value) === null || _state$unifiedPrivacy2 === void 0 ? void 0 : _state$unifiedPrivacy2.unified_privacy) === UnifiedPrivacy.unified_privacy.OPEN;
  const isDocumentClosed = !isDocumentOpen;
  const isDocumentReusable = !!((_state$unifiedPrivacy3 = state.unifiedPrivacy.value) === null || _state$unifiedPrivacy3 === void 0 ? void 0 : _state$unifiedPrivacy3.is_reusable);
  const isDocumentCopyrighted = !isDocumentReusable;
  if (!isOwner) {
    return {
      disabled: true,
      reason: 'notAllowedShared'
    };
  }
  if (isDocumentOpen && (isPermissionNotAllowedWithCurrentLicense(unifiedPrivacyPermissions === null || unifiedPrivacyPermissions === void 0 ? void 0 : unifiedPrivacyPermissions.closed.unPublished.reusable) || isPermissionNotAllowedWithCurrentLicense(unifiedPrivacyPermissions === null || unifiedPrivacyPermissions === void 0 ? void 0 : unifiedPrivacyPermissions.closed.unPublished.copyrighted))) {
    return {
      disabled: true,
      paywall: {
        reason: 'notAllowedWithCurrentLicense',
        logger: () => getGlassboxLogger().logLoadedPaywallCta({
          cta_paywall_type: 'PRIVACY_SETTINGS',
          paywall_cta_product: documentToProductName(state.document.value)
        })
      }
    };
  }
  if (isDocumentClosed && isDocumentReusable && isPermissionNotAllowedInOrg(unifiedPrivacyPermissions === null || unifiedPrivacyPermissions === void 0 ? void 0 : unifiedPrivacyPermissions.open.unPublished.reusable)) {
    return {
      disabled: true,
      reason: 'notAllowedInOrg'
    };
  }
  if (isDocumentClosed && isDocumentCopyrighted && isPermissionNotAllowedInOrg(unifiedPrivacyPermissions === null || unifiedPrivacyPermissions === void 0 ? void 0 : unifiedPrivacyPermissions.open.unPublished.copyrighted)) {
    return {
      disabled: true,
      reason: 'notAllowedInOrg'
    };
  }
  if (areViewLinksSupported && viewLinkCount > 0) {
    return {
      disabled: true,
      reason: 'notAllowedWithActiveViewLinks'
    };
  }
  return {
    disabled: false
  };
};
const ViewLinkPrivacyDropdown = () => {
  const dispatch = useDispatch();
  const unifiedPrivacy = useSelector(state => {
    var _state$unifiedPrivacy4;
    return (_state$unifiedPrivacy4 = state.unifiedPrivacy.value) === null || _state$unifiedPrivacy4 === void 0 ? void 0 : _state$unifiedPrivacy4.unified_privacy;
  });
  const controlContext = useSelector(controlContextSelector);
  return unifiedPrivacy ? React.createElement(Dumb.ViewLinkPrivacyDropdown, {
    controlContext: controlContext,
    onPrivacyChange: value => dispatch(unifiedPrivacyActions.setUnifiedPrivacy(value)),
    unifiedPrivacy: unifiedPrivacy
  }) : null;
};
export default ViewLinkPrivacyDropdown;